// Libs
import React from 'react';
import { Typography } from '@mui/material';
import { useStyles } from './OutOfStockLabelStyles';

export const resolveFontVariant = ({ device }) => {
  const { isMobileMode } = device;

  if (!isMobileMode) {
    return 'textSmBold';
  } else {
    return 'textXsSemibold';
  }
};

const OutOfStockLabel = (props) => {
  const { classes } = useStyles();

  return (
    <Typography
      variant={resolveFontVariant(props)}
      className={classes.label}
      data-testid="out-of-stock-label">
      {props.label}
    </Typography>
  );
};

export default OutOfStockLabel;
